import Attribute, { Type } from './Attribute';

const LeaderPageAttributes = {
	id: Attribute({
		title: 'default.id',
		field: 'id',
		type: Type.Number,
		sortable: false,
		selectableColumn: false
	}),
	name: Attribute({
		title: 'default.name',
		field: 'name',
		type: Type.String
	}),
	score: Attribute({
		title: 'default.pageValue',
		field: 'score',
		type: Type.Number
	}),
	pageImpression: Attribute({
		title: 'default.visits',
		field: 'pageImpression',
		type: Type.Number
	}),
	url: Attribute({
		title: 'default.url',
		field: 'url',
		type: Type.String
	}),
	keywords: Attribute({
		title: 'default.keywords',
		field: 'keywords',
		type: Type.String
	}),
	hide: Attribute({
		title: 'default.hide',
		field: 'hide',
		type: Type.Boolean
	})
};

export default LeaderPageAttributes;
